export const SELECTED_FOR_VERIFICATION_LOADING =
  'SELECTED_FOR_VERIFICATION_LOADING';
export const GET_SELECTED_FOR_VERIFICATION = 'GET_SELECTED_FOR_VERIFICATION';
export const SELECTED_FOR_VERIFICATION_ERROR =
  'SELECTED_FOR_VERIFICATION_ERROR';
export const SELECTED_FOR_VERIFICATION_CLEAR_ERROR =
  'SELECTED_FOR_VERIFICATION_CLEAR_ERROR';
export const SELECTED_FOR_VERIFICATION_SAVE_FILTERS =
  'SELECTED_FOR_VERIFICATION_SAVE_FILTERS';
export const DECLINE_FOR_VERIFICATION_SUCCESS =
  'DECLINE_FOR_VERIFICATION_SUCCESS';
export const SELECTED_FOR_VERIFICATION_AVAILABLE_TO_DECLINE =
  'SELECTED_FOR_VERIFICATION_AVAILABLE_TO_DECLINE';
export const SAVE_SELECTED_FILTER_OPTION = 'SAVE_SELECTED_FILTER_OPTION';



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/state/types.js